<template>
  <h1 class="text-center">FAQ</h1>
</template>

<script>
export default {
  name: "FAQ"
}
</script>

<style scoped>

</style>